import React, { useState } from 'react';
import './FAQ.css';

const faqData = [
    {
        question: "Do you provide handyman services near me?",
        answer: "Yes! We specialize in providing reliable handyman services across our local service area. We're the top choice for homeowners looking for a professional and local handyman near them."
    },
    {
        question: "How long does a typical TV mounting take?",
        answer: "Most TV mounting jobs take between 45 minutes to 1.5 hours, depending on the wall type and whether cable concealment is required."
    },
    {
        question: "Do you offer same-day handyman services?",
        answer: "We often have slots available for urgent home repairs. If you call before 10 AM, there is a high chance we can provide same-day service for those needing immediate assistance."
    },
    {
        question: "Are your furniture assembly services flat-rate?",
        answer: "We offer transparent, flat-rate pricing for IKEA, Wayfair, and Amazon furniture assembly. You'll know the cost upfront with no hidden hourly fees."
    },
    {
        question: "What areas do you serve?",
        answer: "We primarily focus on Northridge and the San Fernando Valley, providing expert services in Reseda, Granada Hills, Porter Ranch, Chatsworth, and the surrounding neighborhoods."
    }
];

const FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="faq-section" id="faq">
            <div className="faq-container">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                <div className="faq-list">
                    {faqData.map((item, index) => (
                        <div
                            key={index}
                            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="faq-question">
                                {item.question}
                                <span className="faq-icon">{activeIndex === index ? '−' : '+'}</span>
                            </div>
                            {activeIndex === index && (
                                <div className="faq-answer">
                                    <p>{item.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
